import http from './http'


export function getSeries() {
  return http.get("/v1/notifications/admin/series", {withCredentials: true})
}

export function createSeriesByTitle(title) {
  return http.post("/v1/notifications/admin/series",{"series": {"title": title}}, {withCredentials: true})
}

export function getSeriesBySeriesId(id) {
  return http.get(`/v1/notifications/admin/series/${id}`, {withCredentials: true})
}

export function createTemplateForSeries(series_id, template) {
  return http.post(`/v1/notifications/admin/series/${series_id}/templates`, {"template": template}, {withCredentials: true})
}

export function createAssignmentForSeries(series_id, assignment) {
  return http.post(`/v1/notifications/admin/series/${series_id}/assignments`, {"assignment": assignment}, {withCredentials: true})
}

export function searchMembers(name) {
  if(name) {
    return http.get("/v1/profile/members", {params: {q: `name:*${name}*`}}, {withCredentials: true})
  }else{
    return http.get("/v1/profile/members", {withCredentials: true})
  }

}
